<template>
    <b-modal
      :key="_key"
      v-model="shown"

      size="xl"
      centered
      no-close-on-esc
      no-close-on-backdrop
      class="EditorModal">
       <div slot="modal-header" class="px-2">
           <h4>{{table_name}}</h4>
       </div>
      <div>
            <list-key-insight
                :values="nested_data"
            >

            </list-key-insight>
      </div>

      <div slot="modal-footer" style="width: 100%">
        <div class="text-right">
          <b-button @click="OnClose" variant="outline" class="px-3" size="md">
            Cancel
          </b-button>

        </div>
      </div>

    </b-modal>
</template>
<script>
import ListKeyInsight from './ListKeyInsight'
export default {
    name: 'NestedTable',
    components:{
        ListKeyInsight
    },
    props:{
        table_name: String,
        nested_data: Array,
        _key:[String, Number, Date]

    },
    data(){
        return{
            shown: true,
        }
    },
    methods:{
        OnClose(changed=false){
            this.shown = false;
            this.$emit('close', changed);

        }
    }
}
</script>
<style>
@media (min-width: 1200px) {
    .EditorModal .modal-lg {
      max-width: 950px;
    }
  }

</style>
